import { render, staticRenderFns } from "./hoteldetail.vue?vue&type=template&id=2492a936&scoped=true&"
import script from "./hoteldetail.vue?vue&type=script&lang=js&"
export * from "./hoteldetail.vue?vue&type=script&lang=js&"
import style0 from "./hoteldetail.vue?vue&type=style&index=0&id=2492a936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492a936",
  null
  
)

export default component.exports